export enum DropdownOptionVariant {
  DEFAULT = "default",
  WITH_CHECKBOX = "checkbox",
  WITH_ICON = "icon",
  COPYABLE = "copyable"
}

export interface DropdownOptionItem {
  label: string;
  value: string;
  variant?: DropdownOptionVariant;
  disabled?: boolean;
  options?: DropdownOptionItem[];
  isMultiSelect?: boolean;
}
